import Phaser from 'phaser';
import { eventBus, EVENTS } from '../EventBus';
import type { RoundResult, ScreenPayload } from '../types';
import { drawDigitalCityBackdrop } from './sceneArt';

export class ResultsScene extends Phaser.Scene {
  private result!: RoundResult;
  constructor() { super('ResultsScene'); }
  init(data: { result: RoundResult }): void { this.result = data.result; }

  create(): void {
    drawDigitalCityBackdrop(this, true);
    const success = this.result.completed;
    const communityMode = this.result.mode !== 'packet' && this.result.mode !== 'bonus';
    const server = this.add.container(800, 190).setDepth(5);
    const pulse = this.add.circle(0, 0, 96, success ? 0x1ed8ff : 0xff8a34, 0.08).setStrokeStyle(7, success ? 0x1ed8ff : 0xff8a34, 0.9);
    const tower = this.add.graphics();
    tower.fillStyle(0x06152f, 1).fillRoundedRect(-52, -70, 104, 140, 12);
    tower.lineStyle(6, success ? 0x1ed8ff : 0xff8a34, 1).strokeRoundedRect(-52, -70, 104, 140, 12);
    [-42, 0, 42].forEach((y) => { tower.lineStyle(3, 0xffffff, 0.85).lineBetween(-33, y, 27, y); tower.fillStyle(success ? 0x56e39f : 0xff8a34, 1).fillCircle(34, y - 10, 5); });
    const mark = this.textures.exists('turncom360-mark') ? this.add.image(0, 0, 'turncom360-mark').setDisplaySize(58, 50) : this.add.image(0, 0, 'turncom360-mark');
    server.add([pulse, tower, mark]);
    if (success) this.tweens.add({ targets: pulse, scale: 1.45, alpha: 0, duration: 720, repeat: -1, ease: 'Cubic.Out' });
    this.add.text(800, 318, success ? (communityMode ? 'COMMUNITY CONNECTED!' : 'PACKET DELIVERED!') : 'KEEP THE SIGNAL MOVING', { fontFamily: 'Arial Black, Arial', fontSize: '46px', color: success ? '#ffffff' : '#ffb37a' }).setOrigin(0.5);
    this.add.text(800, 370, success ? (communityMode ? `${this.result.community?.toUpperCase()} IS GLOWING` : 'BONUS POINTS ADDED') : 'THE COMMUNITY IS READY FOR ANOTHER RUN', { fontFamily: 'Arial, sans-serif', fontSize: '16px', fontStyle: 'bold', color: success ? '#1ed8ff' : '#8fdfff', letterSpacing: 3 }).setOrigin(0.5);
    if (communityMode) {
      const outcomes = ['⌂ HOME ACCESS', '▣ LEARNING ACCESS', '+ HEALTH ACCESS', '◆ BUSINESS ACCESS', '✦ LOCAL OPPORTUNITY'];
      outcomes.forEach((outcome, index) => this.add.text(235 + index * 283, 430, outcome, { fontFamily: 'Arial Black, Arial', fontSize: '13px', color: index === 4 ? '#ffd15c' : '#ffffff', backgroundColor: '#071b3bee', padding: { x: 12, y: 9 } }).setOrigin(0.5));
    }
    eventBus.emit<ScreenPayload>(EVENTS.screen, { name: 'results', result: this.result });
  }
}
